import Vue from "vue";
import TranslationService from "../services/TranslationService";
const ApiService = require("../services/ApiService");

export default Vue.component("order-history-list-item", {

    props:
    {
        template:
        {
            type: String,
            default: "#vue-order-history-list-item"
        },
        orderDetailsTemplate:
        {
            type: String,
            default: "Ceres::MyAccount.Partials.OrderHistoryListItemDetails"
        },
        order:
        {
            type: Object,
            required: true
        },
        allowPaymentProviderChange:
        {
            type: Boolean,
            default: true
        },
        allowReturn:
        {
            type: Boolean,
            default: true
        },
        error:
        {
            type: Array,
            default: () => []
        }
    },

    data()
    {
        return {
            waiting: false,
            isDataLoaded: false,
            showAllOrderItems: false,
            fullOrder:null,
            pieces:[],
            resetCompleteItem:false,
            finished:false,
            fixData:[],
            currentFixDataSlide:1
        };
    },
    filters: {
        errorOrders: function(items)
        {
            const returnVal = [];

            for (let i = 0; i < items.length; i++)
            {
                if (Object.hasOwnProperty.call(items[i], "stockError"))
                {
                    returnVal.push(items[i]);
                }
            }
            return returnVal;
        },
        getName: function(names)
        {
            for (let i = 0; i < names.length; i++)
            {
                if (names[i].lang == App.language)
                {
                    return names[i].name;
                }
            }
            return names;

        }
    },
    methods:
    {
        isActive(value, index, item)
        {
            let activeValue = false;

            for (let i = 0; i < item.stockError.choosenValues.length; i++)
            {
                if (item.stockError.choosenValues[i].value == value && item.stockError.choosenValues[i].index == index)
                {
                    activeValue = true;
                }
            }
            return activeValue;
        },
        calcSum(quantity, choosen)
        {
            return (parseFloat(quantity) - parseFloat(choosen)).toFixed(1);
        },
        sendData(data)
        {
            let found = false;

            for (let i = 0; i < this.fixData.length; i++)
            {
                if (this.fixData[i].itemVariationId == data.itemVariationId)
                {
                    found = true;
                    this.fixData[i] = data;
                    console.log("data", data);
                }
            }
            if (found == false)
            {
                this.fixData.push(data);
            }
            $("#replaceSlider .owl-carousel").trigger("next.owl.carousel");
            this.currentFixDataSlide = this.currentFixDataSlide + 1;
        },
        addRemoveChosenValue(value, index, item)
        {
            let indexValue = -1;

            for (let i = 0; i < item.stockError.choosenValues.length; i++)
            {
                if (index == item.stockError.choosenValues[i].index)
                {
                    indexValue = index;
                }
            }
            if (indexValue > -1)
            {
                let getCorrectIndex = -1;

                for (let i2 = 0; i2 < item.stockError.choosenValues.length; i2++)
                {
                    if (parseInt(item.stockError.choosenValues[i2].index) == parseInt(indexValue))
                    {
                        getCorrectIndex = i2;
                    }
                }
                item.stockError.choosenValues.splice(getCorrectIndex, 1);
                item.stockError.sumOfPieces = String((parseFloat(item.stockError.sumOfPieces) - parseFloat(value)).toFixed(1));
            }
            else
            {
                const dataToPush =
                {
                    "index":index,
                    "value":value
                };

                item.stockError.choosenValues.push(dataToPush);
                item.stockError.sumOfPieces = String((parseFloat(item.stockError.sumOfPieces) + parseFloat(value)).toFixed(1));
            }
        },

        showErrorModal(orderid)
        {
            $("#solveErrorModal_"+orderid).modal({ backdrop: "static", keyboard: false });
        },
        solveProblem(orderid)
        {
            const _self = this;

            this.waiting = true;
            const dataToSend = [];

            for (let i = 0; i < this.fixData.length; i++)
            {
                const data =
                {
                    "pieces"            : this.fixData[i].stockError.pieces,
                    "number"            : this.fixData[i].more.variation.number,
                    "currency"          : this.fixData[i].amounts[0].currency,
                    "surcharge"         : this.fixData[i].amounts[0].surcharge,
                    "priceOriginalGross": this.fixData[i].amounts[0].priceOriginalGross,
                    "orderItemName"     : this.fixData[i].orderItemName,
                    "variationId"       : this.fixData[i].itemVariationId,
                    "fullReplace"       : this.fixData[i].stockError.fullReplace,
                    "choosenValues"     : this.fixData[i].stockError.choosenValues,
                    "stock"             : this.fixData[i].stockError.stock,
                    "sumOfPieces"       : this.fixData[i].stockError.sumOfPieces,
                    "quantityOrder"     : this.fixData[i].quantity,
                    "rest"              : (parseFloat(this.fixData[i].quantity) - parseFloat(this.fixData[i].stockError.sumOfPieces)).toFixed(1)
                };

                dataToSend.push(data);
            }
            const orderCorrectionCreate=
            {
                "orderId":orderid,
                "solves":dataToSend
            };

            ApiService
                .post("/ordercorrection/create/", orderCorrectionCreate)
                .done(response =>
                {
                    console.log(response);
                    location.reload();
                    _self.waiting = false;
                    $("#solveErrorModal_"+orderid).modal("hide");
                });

        },
        checkError()
        {
            for (let i = 0; i < this.error.length; i++)
            {
                if (this.error[i].orderId == this.order.id)
                {
                    return true;
                }
            }
            return false;
        },
        getErrorForThisOrder()
        {
            const currentError = [];

            for (let i = 0; i < this.error.length; i++)
            {
                if (this.error[i].orderId == this.order.id)
                {
                    currentError.push(this.error[i]);
                }
            }
            if (currentError.length > 0)
            {
                return currentError;
            }
            else
            {
                return [];
            }
        },
        loadOrderDetailTemplate()
        {
            if (!this.waiting && !this.isDataLoaded)
            {
                this.waiting = true;

                const testing = window.ceresEnv !== "testing" ? "" : "&env=testing";

                ApiService
                    .get("/rest/io/order/template?template=" + this.orderDetailsTemplate + "&orderId=" + this.order.id + testing)
                    .done(orderDetails =>
                    {
                        const compiled = Vue.compile(orderDetails);
                        const component = new Vue({
                            data: {
                                showAllOrderItems: this.showAllOrderItems,
                                allowPaymentProviderChange: this.allowPaymentProviderChange,
                                allowReturn: this.allowReturn
                            },
                            store: window.ceresStore,
                            render: compiled.render,
                            staticRenderFns: compiled.staticRenderFns
                        });

                        component.$mount(this.$refs.orderDetailsContainer);
                        if (this.checkError(this.order))
                        {
                            const data = {
                                "orderId" : this.order.id,
                                "variations": this.getErrorForThisOrder()[0].variations
                            };

                            ApiService
                                .post("/ordercorrection/", data)
                                .done(response =>
                                {
                                    // console.log("response", response);
                                    for (let i = 0; i < response.items.length; i++)
                                    {
                                        if (Object.hasOwnProperty.call(response.items[i], "stockError"))
                                        {
                                            if (response.items[i].stockError.pieces === null)
                                            {
                                                response.items[i].stockError.pieces = [];
                                            }
                                            if (response.items[i].stockError.choosenValues === null)
                                            {
                                                response.items[i].stockError.choosenValues = [];
                                            }
                                            response.items[i].stockError.choosenValues = [];
                                            response.items[i].stockError.sumOfPieces = 0;
                                            response.items[i].stockError.fullReplace = false;
                                        }
                                    }

                                    this.fullOrder = response.items;


                                });
                        }
                        else
                        {
                            this.isDataLoaded = true;
                        }

                    })
                    .always(() =>
                    {
                        this.waiting = false;
                    });
            }
        },

        getWarrantyTooltip(referenceOrderId)
        {
            return TranslationService.translate("Ceres::Template.orderHistoryWarranty", { id: referenceOrderId });
        }
    }
});
